export const VACANCY_POSITION = '/vacancy-positions'
